<div id="loader" [ngClass]="{relative: isRelative, absolute: !isRelative}">
  <div id="shadow"></div>
  <div id="box"></div>
</div>
